//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
export default {
  props: {
    show: { type: Boolean, default: false },
    variableText: { type: String, default: '' },
    varType: { type: String, default: '' },
  },
  data() {
    return {
      systemVariableOptions: [
        {
          label: '上一节点处理人',
          value: 'previous_assignees',
        },
        {
          label: '发起人',
          value: 'start_user',
        },
        {
          label: '上一节点处理人岗位上级',
          value: 'func.Leader(previous_assignees)',
        },
      ],
      varText: '',
      filterText: '',
      startObjectFiledsList: [],
      treeData: [],
      treeProps: {
        children: 'children',
        label: 'label',
      },
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  computed: {
    ...mapGetters({
      businessEntityList: 'notice/getObjectList',
      startNodeObject: 'workflow/getStartNodeObject',
    }),
    showDialog: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('cancel', val);
      },
    },
  },
  mounted() {
    this.varText = this.variableText;
    if (this.startNodeObject) {
      const objId = this.businessEntityList.find(
        (object) => object.name === this.startNodeObject,
      )?.id;
      const objDisPlayName = this.businessEntityList.find(
        (object) => object.name === this.startNodeObject,
      )?.display_name;
      const bizNode = {
        id: this.startNodeObject,
        label: `${objDisPlayName}-${this.startNodeObject}`,
        children: [],
      };
      this.$request({
        url: this.$api.metaGetObjectFields,
        data: {
          object_id: objId,
        },
      }).then((data) => {
        bizNode.children = data.fields.map((fie) => ({
          id: fie.name,
          label: `${fie.display_name}-${fie.name}`,
        }));
        this.treeData.push(bizNode);
      });
    }
  },
  methods: {
    handleClose() {
      this.varText = '';
      this.showDialog = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    insertSystemVariable(e) {
      const selector = '.varilable_text .el-textarea__inner';
      const dom = document.querySelector(selector);
      this.varText = `${this.varText.substring(
        0,
        dom.selectionStart,
      )}{{${e}}}${this.varText.substring(dom.selectionEnd, dom.textLength)}`;
    },
    handleNodeClick(e, data) {
      const selector = '.varilable_text .el-textarea__inner';
      const dom = document.querySelector(selector);
      if (!e.children) {
        this.varText = `${this.varText.substring(0, dom.selectionStart)}{{${data.parent.data.id}.${
          e.id
        }}}${this.varText.substring(dom.selectionEnd, dom.textLength)}`;
      }
    },
    save() {
      this.$emit('insertion', this.varText);
      this.handleClose();
    },
  },
};
